<template>
  <div class="choice">
    <!-- 计算3-->
    <div class="choiceItem" v-if="data.questionType == 3">
      <div class="choiceTitle">
        【计算题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div
        class="tinymce"
        v-for="choiceItem in data.optionList"
        :key="choiceItem.optionId"
      >
        <tinymce
          ref="editor"
          v-model="choiceItem.answer"
          @eventHandle="standardSlotChange"
        ></tinymce>
      </div>
    </div>

    <!-- 简答6 -->
    <div class="choiceItem" v-if="data.questionType == 6">
      <div class="choiceTitle">
        【简答题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div
        class="tinymce"
        v-for="choiceItem in data.optionList"
        :key="choiceItem.optionId"
      >
        <tinymce ref="editor" v-model="choiceItem.answer"></tinymce>
      </div>
    </div>

    <!-- 论述7 -->
    <div class="choiceItem" v-if="data.questionType == 7">
      <div class="choiceTitle">
        【论述题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div
        class="tinymce"
        v-for="choiceItem in data.optionList"
        :key="choiceItem.optionId"
      >
        <tinymce
          ref="editor"
          v-model="choiceItem.answer"
          @eventHandle="standardSlotChange"
        ></tinymce>
      </div>
    </div>

    <!-- 案例分析8 -->
    <div class="choiceItem" v-if="data.questionType == 8">
      <div class="choiceTitle">
        【案例分析题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div
        class="tinymce"
        v-for="choiceItem in data.optionList"
        :key="choiceItem.optionId"
      >
        <tinymce
          ref="editor"
          v-model="choiceItem.answer"
          @eventHandle="standardSlotChange"
        ></tinymce>
      </div>
    </div>

    <!-- 综合9 -->
    <div class="choiceItem" v-if="data.questionType == 9">
      <div class="choiceTitle">
        【综合题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div
        class="tinymce"
        v-for="choiceItem in data.optionList"
        :key="choiceItem.optionId"
      >
        <tinymce
          ref="editor"
          v-model="choiceItem.answer"
          @eventHandle="standardSlotChange"
        ></tinymce>
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
export default {
  components: {
    Tinymce,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    allArr: {
      type: Array,
      default: () => [],
    },
    num: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      single: [],
      multiple: [],
    };
  },
  watch: {
    allArr() {
      // console.log(val);
    },
  },
  mounted() {},
  methods: {
    standardSlotChange() {
      // console.log(val.data);
    },
  },
};
</script>

<style scoped lang="scss">
.choice {
  .active {
    background-color: #3671bf !important;
    color: #ffffff !important;
  }
  .tinymce {
    margin-bottom: 30px;
  }
  .choiceItem {
    .choiceTitle {
      font-size: 16px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: bold;
      color: #3671bf;
      .score {
        color: #909399;
      }
    }

    .testName {
      display: flex;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #333333;
      margin-top: 30px;
      margin-bottom: 24px;
      .name {
        margin-left: 10px;
        width: 100%;
        height: auto;
      }
    }
    .optionChoice {
      display: flex;
      align-items: center;
      width: 100%;
      .optionTag {
        width: 28px;
        line-height: 28px;
        background: #ffffff;
        border: 1px solid #d8dee6;
        text-align: center;
        border-radius: 50%;
        margin-right: 10px;
      }
      .optionName {
        width: calc(100% - 38px);
        height: auto;
      }
    }
    ::v-deep .is-checked {
      .optionTag {
        background-color: #3671bf !important;
        color: #fff !important;
      }
    }
  }
  ::v-deep .el-radio-group {
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #545454;
      line-height: 14px;
    }
    .el-radio {
      width: 100%;
    }
  }
  ::v-deep .el-checkbox-group {
    .el-checkbox {
      display: block;
    }
    .el-checkbox__inner {
      display: none;
    }
    .el-checkbox__label {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #545454;
      line-height: 14px;
    }
    .el-checkbox {
      width: 100%;
      margin-bottom: 16px;
    }
  }
}
</style>
